import React, {
    useEffect,
} from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Link, Typography } from '@material-ui/core';
import { useHistory } from 'react-router';

import logoWhite from '../../images/logo_white.png';

type PageProps = {
    children: React.ReactNode,
    title?: string,
    className?: string,
    style?: React.CSSProperties,
};

Page.defaultProps = {
    title: '',
    className: '',
    style: {},
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    page: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,
        overflowX: 'hidden',
    },
    footer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        padding: theme.spacing(2, 1),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '& .MuiLink-root': {
            margin: theme.spacing(0, 0.5),
            color: 'inherit',
        },
    },
    logo: {
        height: 24,
        marginBottom: 4,
        cursor: 'pointer',
    },
}));

function Page(props: PageProps): React.ReactElement {
    const {
        children,
        title,
        className,
        style = Page.defaultProps.style,
    } = props;
    const classes = useStyle();
    const history = useHistory();

    useEffect(() => {
        if (title) {
            window.document.title = title;
        }
    }, [title]);

    function handleLogoClick() {
        history.replace('/home');
    }

    return (
        <div className={clsx(classes.page, className)} style={style}>
            <div style={{ flex: 1 }}>
                { children }
            </div>
            <div className={classes.footer}>
                <img className={classes.logo} src={logoWhite} alt="logo" onClick={handleLogoClick} />
                <Typography variant="caption">+886-6-5058888</Typography>
                <Typography variant="caption">744092台南市新市區南部科學園區環東路一段27號</Typography>
                <Typography variant="caption" style={{ marginTop: 4 }}>
                    Copyright @ 超淨精密科技股份有限公司
                    <Typography variant="caption">All rights reserved</Typography>
                </Typography>
                <div>
                    <Link onClick={() => history.push('/privacy')}>隱私權政策</Link>
                    <Link onClick={() => history.push('/terms')}>使用條款</Link>
                </div>
            </div>
        </div>
    );
}

export { Page };
